/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "adminusersapi",
            "endpoint": "https://nuums4lpw7.execute-api.us-east-2.amazonaws.com/production",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://av6xf4ldw5hbbhwkwevvgduf5q.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-rfkupwobi5b2jh3zshgovg7bqe",
    "aws_cognito_identity_pool_id": "us-east-2:72d6007d-2ed0-4286-81ca-1ae387e30d70",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_3c0hm73ZA",
    "aws_user_pools_web_client_id": "451dgbnccas10cplk629egvngm",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "rssv-file-validatorfb2ca-production",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
